import React, { useState } from 'react';
import { updateApplication } from '../API/application';
import { useDialogsContext } from '../../contexts/Dialog';
import { useEventTrackerContext } from '../../contexts/EventTracker';
import { applicationStatus } from '../../utils/enums';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import TableHeader from './PlansTableHeader';
import TableBody from './PlansTableBody';
import Filter from './FilterStatus';
import PlanDiscovery from './PlanDiscovery/Dialog';
import cloneDeep from 'lodash.clonedeep';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 900,
  },
}));

export default function PlansTable({
  plans,
  setPlans,
  deletePlan,
  setLoading,
}) {
  const classes = useStyles();
  const dialog: any = useDialogsContext();
  const { trackEvent } = useEventTrackerContext();
  const [filter, setFilter] = useState(null);
  const [planForPlanDiscovery, setPlanForPlanDiscovery] = useState(null);
  const headers = ['', 'Plan name', 'Start date', 'Status', ''];

  function userCompletedPlanDiscovery(id: string, expand = false) {
    const plansCopy = cloneDeep(plans);
    const updatedPlans = plansCopy.map((plan) => {
      if (plan.id === id) {
        plan['completedPlanDiscovery'] = true;
        if (expand) plan['expanded'] = true;
      }
      return plan;
    });
    setPlans(updatedPlans);
    const currentPlan = plansCopy.find((plan) => plan.id === id);
    trackEvent({
      event: 'completed_plan_discovery',
      application_id: currentPlan?.id,
      application_name: currentPlan?.name,
      application_type: currentPlan?.type,
    });
  }

  async function openPlanDiscovery(plan: any) {
    setPlanForPlanDiscovery(plan);
    dialog.open('planDiscovery');
    try {
      await updateApplication({ id: plan.id, completedPlanDiscovery: true });
      trackEvent({
        event: 'viewed_plan_discovery',
        application_id: plan?.id,
        application_name: plan?.name,
      });
    } catch (error) {
      console.log(
        `Error marking plan discovery complete for plan ${plan.id}`,
        error,
      );
    }
  }

  return (
    <React.Fragment>
      <Container className={classes.root}>
        <Filter
          onChange={(filter) => {
            setFilter(filter === 'all' ? null : filter);
          }}
        />
        <TableContainer component={Paper}>
          <Table>
            <TableHeader headers={headers} />
            <TableBody
              plans={plans.filter((plan) => {
                const isCloneApp =
                  plan.status === applicationStatus.submitted.status &&
                  plan.originApplication;

                if (filter === null || filter === 'all')
                  return (
                    plan.status !== applicationStatus.archived.status &&
                    plan.status !== applicationStatus.rejected.status &&
                    !isCloneApp
                  );
                if (isCloneApp) return undefined;
                return plan.status === filter;
              })}
              setPlans={setPlans}
              numColumns={headers.length}
              openPlanDiscovery={openPlanDiscovery}
              deletePlan={deletePlan}
              setLoading={setLoading}
            />
          </Table>
        </TableContainer>
      </Container>
      {planForPlanDiscovery && (
        <PlanDiscovery
          plan={planForPlanDiscovery}
          userCompletedPlanDiscovery={userCompletedPlanDiscovery}
        />
      )}
    </React.Fragment>
  );
}
